/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Test_RunningInputs */

const en_admin_settings_test_running = /** @type {(inputs: Admin_Settings_Test_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running...`)
};

const zh_admin_settings_test_running = /** @type {(inputs: Admin_Settings_Test_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`测试中...`)
};

/**
* | output |
* | --- |
* | "Running..." |
*
* @param {Admin_Settings_Test_RunningInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_test_running = /** @type {((inputs?: Admin_Settings_Test_RunningInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Test_RunningInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_test_running(inputs)
	return zh_admin_settings_test_running(inputs)
});
export { admin_settings_test_running as "admin.settings.test.running" }